import { AxiosResponse } from 'axios';
declare module 'axios' {
  interface AxiosResponse {
    code: Code;
    token: string;
    role: string;
    message: string;
    [key: string]: any;
  }
}

export enum Code {
  SUCCESS,
  PARAMS_ERROR,
  PASSWORD_ERROR,
  BACK_END_ERROR = -1, // 后端逻辑错误
  ACCOUNT_WARNING = 16, // 账号风险
  FREQUENT_REQUESTS = 100, // 频繁请求
  SDX_UPGRADE = 1405, // 登录成功
  NOT_FIRST_LOGIN = 20002, // 不是第一次登录
  LOGIN_ERROR = 20401, // 请求密码错误
  EXPIRED = 20402, // 账号到期
  PAUSE = 20403, // 账号停用
  NO_ACCESS = 20405, // 请求没有权限, 比如医院 A 修改医院 B 的订单
  NO_USER_INFO = 20406, // 请求没有该用户的信息
  TOKEN_EMPTY = 50001,
  TOKEN_NO_ACCESS = 50002,
  TOKEN_ERROR = 50008,
  TOKEN_LOGIN = 50013,
  TOKEN_EXPIRATION = 50014,
  TOKEN_SIGNATURE = 50015,
  TOKEN_IGNORE_REQUEST = 50016,

  MSGFAIL = 10001,
  BOUND = 30101, // 微信已绑定
  UNBOUND = 30102, // 微信未绑定
  BIND_OK = 30100, // 綁定成功状态码
  CAN_NOT_ACCESS = 30107, // 不能乱跳
  OLD_VERSION_OK = 3,
}
export enum ErrorCode {
  SUCCESS = 0,
  NEED_LOGOUT = 100099,
  // 空档案
  HANDLE_EMPTY_RECORD = 34010,
  // 今日计划文案
  NEED_HANDLE_TIP_33001 = 33001,
  // 今日计划文案
  NEED_HANDLE_TIP_33000 = 33000,
  // 选择到店配置方案
  SELECT_SCHEDULE_DETAIL = 36000,
  // 系统内部出错
  SYSTEM_ERROR = 500
}

export interface ResponseData extends AxiosResponse {
  data: any;
  message: string;
  code: Code;
  token: string;
  role: string;
  [key: string]: any;
}
